import { Button, HStack, Icon, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoCheckmarkCircleOutline, IoChevronForward } from 'react-icons/io5'
import { useIamStore } from '../../apis/store'

export const LOGIN_CTA_REGISTER = Object.freeze({
  button: 'login-cta-register-btn',
})

const Step: React.FC<{ step: string }> = ({ step }: { step: string }) => {
  return (
    <HStack marginY='20px' spacing={[2, 3, 4, 6, 6]} alignItems='flex-start'>
      <Icon fontSize='4xl' as={IoCheckmarkCircleOutline} />
      <Text color='gray.800'>{step}</Text>
    </HStack>
  )
}

const CtaRegister: React.FC = () => {
  const [t] = useTranslation()
  const { sendEvent } = useIamStore((store) => ({ sendEvent: store.sendEvent }))
  return (
    <>
      <Stack spacing={0}>
        <Text
          alignSelf='left'
          fontWeight='regular'
          fontFamily='Poppins'
          fontSize={['24px', '24px', '24px', '28px', '36px']}
          color='gray.800'
        >
          {t('onboard.home.header.Caption')}
        </Text>
        <Text
          alignSelf='left'
          fontWeight='extrabold'
          color='primaryColors.400'
          fontFamily='Poppins'
          fontSize={['28px', '28px', '28px', '36px', '48px']}
        >
          {t('onboard.home.header.Title')}
        </Text>
      </Stack>
      <Step step={t('onboard.home.steps.First Step')} />
      <Button
        variant='yellow'
        rightIcon={<IoChevronForward />}
        marginTop={6}
        data-testid={LOGIN_CTA_REGISTER.button}
        onClick={() => sendEvent({ type: 'PROCEED' })}
        size='lg'
        fontFamily='Poppins'
        width='100%'
      >
        {t('onboard.home.Continue')}
      </Button>
    </>
  )
}

export default CtaRegister
